import { defineComponent, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

export default defineComponent({
  name: 'MultiselectElement',
  components: {
    Multiselect,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hiddenValue: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    internalSearch: {
      type: Boolean,
      default: true,
    },
    intervalLabel: {
      type: Boolean,
      default: false,
    },
    errorText: { type: Array, required: false },
  },

  setup(_, { expose }) {
    const multiselect = ref<InstanceType<typeof Multiselect> | null>(null)

    expose({
      activate: () => multiselect.value?.activate(),
      deactivate: () => multiselect.value?.deactivate(),
    })
    return { multiselect }
  },
})
